import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { createEmoteApi, storeEmoteApi } from './emoteSlice';
import EmoteForm from './EmoteForm';
import { clearApiValidationErrors } from '~/stores/redux/common/apiValidationErrorSlice';
import { initialValues, pictureAttributeNames } from './initialValue';

function EmoteCreate() {
    const [resetCount, setResetCount] = useState(0);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    const formSubmit = async (values) => {
        dispatch(clearApiValidationErrors()); //clear current api validation errors if any.
        dispatch(storeEmoteApi({ navigate, values }));
    };

    return (
        <EmoteForm
            resetCount={resetCount}
            setResetCount={setResetCount}
            pictureAttributeNames={pictureAttributeNames}
            initialValues={initialValues}
            formSubmit={formSubmit}
        />
    );
}

export default EmoteCreate;
